import buildAsyncCall from './asyncCall'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'

const Types = {
    DASHBOARD_NOTES_LATEST: {
        request: 'DASHBOARD_NOTES_LATEST##REQUEST',
        success: 'DASHBOARD_NOTES_LATEST##SUCCESS',
        failure: 'DASHBOARD_NOTES_LATEST##FAILURE',
    },
}

function fetchNotesLatest() {
    return buildAsyncCall({
        endpoint: `${HUBBLE_API_TOKEN}/dashboard/notes/latest`,
        method: 'GET',
        types: [Types.DASHBOARD_NOTES_LATEST.request, Types.DASHBOARD_NOTES_LATEST.success, Types.DASHBOARD_NOTES_LATEST.failure],
    })
}

export { Types, fetchNotesLatest }
